/* ===========================================================
   Storegen cart drawer — STYLE KORÉ (30/10/2026, règle d'Eric : « Koré partout »).
   Modèle : le tiroir de koreparis.fr (gaine-panier.liquid). Autonome, sans dépendance.
   Les lignes sont dessinées ici depuis l'ÉTAT JSON rendu par Liquid
   (snippets/sg-cart-line-items.liquid, section sg-cart-items) : une seule requête par clic.
   Retirés le 30/10 : minuteur, protection achat, sous-total et économie.
   La barre de paliers par quantité reste, inchangée, éteinte par défaut.
   Banc : scripts/banc-panier-kore.mts.
   =========================================================== */
(function () {
  'use strict';

  var CFG = window.SGCART_CONFIG || {};
  var T = CFG.translations || {};
  var TIERS = (CFG.tiers || [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }])
    .filter(function (t) { return t.enabled !== false; })
    .slice().sort(function (a, b) { return a.qty - b.qty; });
  var MONEY_FORMAT = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '').trim();
  var SECTION = 'sg-cart-items';

  var etat = null;        // le dernier état du panier (JSON de sg-cart-line-items)
  var chain = Promise.resolve();   // serial queue — cart mutations run one after another
  var inflight = 0;
  var loaderTimer = null;

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el() { return document.getElementById('SGCartDrawer'); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ⭐ LES MONTANTS DU TIROIR (30/10/2026, comme Koré le 19/10) : ce que Shopify facture
     (`total_price`, prix des lignes), formaté dans la DEVISE DU PANIER par le navigateur.
     Jamais une table de devises écrite ici, jamais le format de la boutique : un client suisse
     d'une boutique en euros lit ses francs suisses. Boutique en français, euros : « 49,99 € ». */
  var LOCALE = String(CFG.locale || 'fr');
  function montant(cents) {
    var cur = (etat && etat.currency) || CFG.currency || 'EUR';
    var n = Math.round(Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' ' + cur;
    }
  }

  /* ⚠️ LE FORMATEUR DE LA FICHE (lot 2 achat, 28/09/2026), exposé en `window.SGCart.prix`.
     Son jumeau côté serveur est `snippets/sg-price.liquid` : les deux rendent la même chaîne
     sur la fiche produit (sgp-fiche.js l'appelle au changement de variante). Le tiroir ne
     l'utilise PLUS (voir `montant` ci-dessus). Gardé tel quel pour la fiche. */
  var PRIX_FR = CFG.currency === 'EUR' && /^fr/i.test(String(CFG.locale || ''));
  function prixFr(n) {
    n = Math.round(n);
    var signe = n < 0 ? '-' : '';
    n = Math.abs(n);
    var e = Math.floor(n / 100), c = n % 100;
    return signe + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + (c < 10 ? '0' : '') + c + ' €';
  }
  var AUTRE_DEVISE = !!(CFG.currency && CFG.shopCurrency && CFG.currency !== CFG.shopCurrency);
  function prixDeviseMarche(n) {
    try {
      return new Intl.NumberFormat(String(CFG.locale || 'fr'), { style: 'currency', currency: CFG.currency }).format(n / 100);
    } catch (e) { return null; }
  }
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    var n = Number(cents); if (isNaN(n)) n = 0;
    if (PRIX_FR) return prixFr(n);
    if (AUTRE_DEVISE) { var m = prixDeviseMarche(n); if (m) return m; }
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, p, t, d) {
      t = t || ','; d = d || '.';
      var parts = (num / 100).toFixed(p).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var m = MONEY_FORMAT.match(rx), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(n, 0); break;
      case 'amount_with_comma_separator': v = fmt(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(n, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(n, 2, ' ', '.'); break;
      default: v = fmt(n, 2);
    }
    return MONEY_FORMAT.replace(rx, v);
  }

  /* loader overlay — only appears if an operation takes longer than 250ms */
  function showLoader(state) {
    var d = el(); if (!d) return;
    if (state) {
      if (!loaderTimer) loaderTimer = setTimeout(function () { d.classList.add('is-busy'); }, 250);
    } else {
      if (loaderTimer) { clearTimeout(loaderTimer); loaderTimer = null; }
      d.classList.remove('is-busy');
    }
  }
  /* every cart mutation goes through this serial queue, so a click is never
     dropped while another request is still running */
  function enqueue(task) {
    inflight++;
    showLoader(true);
    var run = function () {
      return new Promise(function (resolve) {
        var done = false;
        var finish = function () { if (!done) { done = true; resolve(); } };
        var guard = setTimeout(finish, 14000);
        Promise.resolve().then(task).then(
          function () { clearTimeout(guard); finish(); },
          function () { clearTimeout(guard); finish(); }
        );
      });
    };
    chain = chain.then(run, run).then(function () {
      inflight--;
      if (inflight <= 0) { inflight = 0; showLoader(false); }
    });
    return chain;
  }

  /* ---------- cart API ---------- */
  function api(url, opts) {
    opts = opts || {};
    if (typeof AbortController !== 'undefined') {
      var ctrl = new AbortController();
      opts.signal = ctrl.signal;
      setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000);
    }
    return window.fetch(url, opts);
  }
  function jsonPost(url, body) {
    return api(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }
  function sectionHTML(rep) {
    var raw = rep && rep.sections && rep.sections[SECTION];
    if (!raw) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = raw;
    var inner = tmp.querySelector('#shopify-section-' + SECTION);
    return inner ? inner.innerHTML : raw;
  }
  /* L'état embarqué dans le HTML de la section (ou du tiroir au premier affichage). */
  function parseCart(html) {
    if (!html) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var s = tmp.querySelector('[data-sg-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  /* Repli : la section n'est pas revenue, on lit le panier JSON de Shopify (sans prix barré
     de variante, que /cart.js ne donne pas). Même ordre que le Liquid : du plus ancien au
     plus récent. */
  function etatDepuisPanier(c) {
    if (!c || !c.items) return null;
    var compte = 0;
    var items = c.items.slice().reverse().map(function (i) {
      var cadeau = Number(i.final_line_price) === 0;
      if (!cadeau) compte += i.quantity || 0;
      return {
        key: i.key, titre: i.product_title || i.title, url: i.url, quantite: i.quantity,
        variante: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '',
        image: i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '',
        final: i.final_line_price, barre: Math.max(i.original_line_price || 0, i.final_line_price || 0), cadeau: cadeau,
        remises: (i.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean),
        origine: i.original_line_price, marque: !!(i.properties && i.properties._cadeau)
      };
    });
    return {
      item_count: c.item_count || 0, compte: compte, total_price: c.total_price || 0, currency: c.currency,
      remises_panier: (c.cart_level_discount_applications || []).map(function (d) { return { titre: d.title, montant: d.total_allocated_amount }; }),
      items: items
    };
  }
  /* Une réponse de /cart/*.js (avec `sections`) → l'état. */
  function etatDe(rep) { return parseCart(sectionHTML(rep)) || etatDepuisPanier(rep); }

  function refresh() {
    return enqueue(function () {
      return jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (rep) { applyState(etatDe(rep)); });
    });
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    var d = el(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sgcart-lock');
    var p = $('.sgcart__panel', d); if (p) { try { p.focus({ preventScroll: true }); } catch (e) {} }
  }
  function open() {
    openDrawer();
    // Silent sync — no loader, drawer shows the last known state immediately
    jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
      .then(function (r) { return r.json(); })
      .then(function (rep) { applyState(etatDe(rep)); })
      .catch(function () {});
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sgcart-lock');
  }

  /* ---------- progress bar (paliers par quantité, éteints par défaut) ---------- */
  function buildBar() {
    var bar = $('[data-sgcart-bar]', el());
    if (!bar || bar.children.length) return;
    var n = TIERS.length;
    var html = '<div class="sgcart__bar-track"><div class="sgcart__bar-fill" data-sgcart-fill></div></div><div class="sgcart__nodes">';
    TIERS.forEach(function (t, i) {
      html += '<div class="sgcart__node" data-tier="' + i + '" style="left:' + ((i + 1) * (100 / n)) + '%">' +
                '<span class="sgcart__node-dot"></span><span class="sgcart__node-label">' + t.pct + '%</span></div>';
    });
    bar.innerHTML = html + '</div>';
  }
  function currentTier(c) { var r = null; TIERS.forEach(function (t) { if (c >= t.qty) r = t; }); return r; }
  function nextTier(c) { for (var i = 0; i < TIERS.length; i++) { if (c < TIERS[i].qty) return TIERS[i]; } return null; }

  function renderProgress(count) {
    var d = el();
    var progEl = $('[data-sgcart-progress]', d);
    // Hide progress bar entirely when no tiers configured (the default)
    if (!TIERS.length || count === 0) { if (progEl) progEl.style.display = 'none'; return; }
    if (progEl) progEl.style.display = '';

    var fill = $('[data-sgcart-fill]', d), msg = $('[data-sgcart-msg]', d);
    var n = TIERS.length, maxQty = TIERS[n - 1].qty;
    var cur = currentTier(count), nxt = nextTier(count);
    var pct;
    if (count >= maxQty) { pct = 100; }
    else {
      var seg = 0, startQty = 0, endQty = TIERS[0].qty, prev = 0;
      for (var k = 0; k < n; k++) {
        if (count < TIERS[k].qty) { seg = k; startQty = prev; endQty = TIERS[k].qty; break; }
        prev = TIERS[k].qty;
      }
      var segW = 100 / n;
      pct = (seg * segW) + (((count - startQty) / (endQty - startQty)) * segW);
    }
    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';

    var m = '';
    if (count > 0) {
      if (cur && nxt) {
        var need = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need)
          : '<span class="sgcart__msg-win">' + cur.pct + '% débloqué</span> &mdash; ajoutez <strong>' + need + '</strong> article' + (need > 1 ? 's' : '') + ' pour <strong>' + nxt.pct + '% de remise</strong>';
      } else if (cur && !nxt) {
        m = cur.text || ('<span class="sgcart__msg-win">Vous avez débloqué la remise max de ' + cur.pct + '%</span>');
      } else if (nxt) {
        var need2 = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need2)
          : 'Ajoutez <strong>' + need2 + '</strong> article' + (need2 > 1 ? 's' : '') + ' pour débloquer <strong>' + nxt.pct + '% de remise</strong>';
      }
    }
    if (msg) msg.innerHTML = m;
    $$('.sgcart__node', d).forEach(function (node, i) {
      node.classList.toggle('is-reached', count >= TIERS[i].qty);
    });
  }

  /* ---------- les lignes, à la Koré ---------- */
  var POUBELLE = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 6h16M9 6V4h6v2M6 6l1 14h10l1-14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var ETIQUETTE = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8z" fill="currentColor"/><circle cx="7.5" cy="8.5" r="1.6" fill="#e3f5e6"/></svg>';
  function uniques(liste) {
    var vus = {};
    return (liste || []).filter(function (t) { if (!t || vus[t]) return false; vus[t] = 1; return true; });
  }
  function etiquette(titre) { return '<span class="sgcart-item__remise">' + ETIQUETTE + '<span>' + escapeHtml(titre) + '</span></span>'; }

  function itemHTML(it) {
    var url = escapeHtml(it.url || '#');
    var img = it.image
      ? '<img src="' + escapeHtml(it.image) + '" alt="" width="76" height="76" loading="lazy" decoding="async">'
      : '<span aria-hidden="true"></span>';
    var qte = it.cadeau
      /* Un cadeau à 0 n'a pas de « + » : le « + » ajoutait une unité PAYANTE chez Koré (gants à 30 €). */
      ? '<p class="sgcart-item__qte-texte">' + escapeHtml(T.quantite || 'Quantité') + '&nbsp;: ' + it.quantite + '</p>'
      : '<div class="sgcart-item__qty">' +
          '<button type="button" class="sgcart-qty__btn" data-sgcart-minus aria-label="' + escapeHtml(T.moins || 'Un de moins') + '">&minus;</button>' +
          '<span class="sgcart-qty__val">' + it.quantite + '</span>' +
          '<button type="button" class="sgcart-qty__btn" data-sgcart-plus aria-label="' + escapeHtml(T.plus || 'Un de plus') + '">+</button>' +
        '</div>';
    var barre = Number(it.barre) || 0, fin = Number(it.final) || 0;
    var prix = (barre > fin ? '<s>' + montant(barre) + '</s>' : '') +
      (it.cadeau ? '<b class="sgcart-item__offert">' + escapeHtml(T.offert || 'Offert') + '</b>' : '<b>' + montant(fin) + '</b>');
    return '<div class="sgcart-item' + (it.cadeau ? ' sgcart-item--cadeau' : '') + '" data-key="' + escapeHtml(it.key) + '">' +
        '<a class="sgcart-item__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="sgcart-item__info">' +
          '<a class="sgcart-item__title" href="' + url + '">' + escapeHtml(it.titre) + '</a>' +
          (it.variante ? '<p class="sgcart-item__opts">' + escapeHtml(it.variante) + '</p>' : '') +
          uniques(it.remises).map(etiquette).join('') +
          qte +
        '</div>' +
        '<div class="sgcart-item__prix">' + prix +
          '<button type="button" class="sgcart-item__remove" data-sgcart-remove aria-label="' + escapeHtml(T.retirer || 'Retirer l’article') + '">' + POUBELLE + '</button>' +
        '</div>' +
      '</div>';
  }
  /* Une remise sur la commande (pas sur une ligne) : son titre réel et ce qu'elle retire,
     sinon la somme des lignes ne tombe pas sur le total du bouton. */
  function remisesPanierHTML(liste) {
    return (liste || []).filter(function (r) { return r && r.titre; }).map(function (r) {
      return '<div class="sgcart__remise-panier">' + etiquette(r.titre) + '<b>&minus;' + montant(r.montant) + '</b></div>';
    }).join('');
  }

  /* La pastille de l'icône panier (en-tête Horizon) : articles choisis, cadeaux exclus. */
  function pastille(n) {
    var icone = document.querySelector('cart-icon.header-actions__cart-icon');
    if (!icone) return;
    var bulle = icone.querySelector('[ref="cartBubble"], .cart-bubble');
    var txt = icone.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
    if (!bulle) return;
    if (n > 0) {
      if (txt) { txt.textContent = n < 100 ? String(n) : '99+'; txt.classList.remove('hidden'); }
      bulle.classList.remove('visually-hidden');
      icone.classList.add('header-actions__cart-icon--has-cart');
    } else {
      if (txt) { txt.textContent = ''; txt.classList.add('hidden'); }
      bulle.classList.add('visually-hidden');
      icone.classList.remove('header-actions__cart-icon--has-cart');
    }
  }

  /* ⚠️ UN CADEAU NE PART PAS SEUL (31/10/2026, MasSiam). Une ligne à 0 € marquée `_cadeau`
     (ajoutée avec une offre) ou dont le prix d'origine est 0 (produit cadeau ajouté depuis sa
     propre page) ne reste pas au panier quand plus AUCUN article payant n'y est : elle est
     retirée. Tant qu'aucun article payant n'est au panier, « Procéder au paiement » ne part pas.
     Une ligne ramenée à 0 par une remise Shopify (prix d'origine > 0, sans `_cadeau`) n'est pas
     retirée ; seul le bouton reste bloqué. Au plus 3 nettoyages par page (jamais de boucle). */
  var nettoyages = 0;
  /* 02/11/2026 (MasSiam) : les cadeaux ont un VRAI prix, qu'une remise Shopify rend gratuit avec le repose-tête. Sans lui,
     la remise saute et ils redeviennent payants : une ligne marquée `_cadeau` n'est jamais un article payant, et elle part
     du panier, quel que soit son prix, dès qu'aucun article payant non marqué n'y reste. */
  function payant(i) { return Number(i.final) > 0 && i.marque !== true; }
  function sansPayant(e) {
    return !!(e && e.items && e.items.length) && !e.items.some(payant);
  }
  function orphelins(e) {
    if (!sansPayant(e)) return [];
    return e.items.filter(function (i) { return i.marque === true || (Number(i.final) === 0 && Number(i.origine) === 0); });
  }
  function retirerOrphelins(e) {
    var o = orphelins(e);
    if (!o.length || nettoyages >= 3) return;
    nettoyages++;
    var maj = {};
    o.forEach(function (i) { maj[i.key] = 0; });
    enqueue(function () {
      return jsonPost('/cart/update.js', { updates: maj, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (rep) { applyState(etatDe(rep)); });
    });
  }
  function bloquerPaiement(d, e) {
    var sp = sansPayant(e);
    var co = $('[data-sgcart-checkout]', d);
    if (co) { if (sp) co.setAttribute('aria-disabled', 'true'); else co.removeAttribute('aria-disabled'); }
    var msg = $('[data-sgcart-sans-payant]', d);
    if (!msg && co && co.parentNode && T.sans_payant) {
      msg = document.createElement('p');
      msg.className = 'sgcart__sans-payant';
      msg.setAttribute('data-sgcart-sans-payant', '');
      msg.textContent = T.sans_payant;
      co.parentNode.insertBefore(msg, co);
    }
    if (msg) msg.hidden = !sp;
  }

  /* ---------- apply cart state ---------- */
  function applyState(e) {
    if (!e || !e.items) return;
    etat = e;
    var d = el(); if (!d) return;
    var vide = !(e.item_count > 0);

    var itemsEl = $('[data-sgcart-items]', d);
    if (itemsEl) itemsEl.innerHTML = vide ? '' : e.items.map(itemHTML).join('') + remisesPanierHTML(e.remises_panier);

    var countEl = $('[data-sgcart-count]', d);
    if (countEl) countEl.textContent = e.compte;

    var emptyEl = $('[data-sgcart-empty]', d); if (emptyEl) emptyEl.hidden = !vide;
    var footEl = $('.sgcart__foot', d); if (footEl) footEl.hidden = vide;
    var livEl = $('[data-sgcart-livraison]', d); if (livEl) livEl.hidden = vide;

    renderProgress(e.compte);

    var coT = $('[data-sgcart-checkout-total]', d);
    if (coT) coT.textContent = montant(e.total_price);
    pastille(e.compte);
    bloquerPaiement(d, e);
    retirerOrphelins(e);
  }

  /* ---------- cart mutations ---------- */
  function changeQty(key, qty) {
    enqueue(function () {
      return jsonPost('/cart/change.js', { id: key, quantity: qty, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (rep) { applyState(etatDe(rep)); });
    });
  }

  /* ⚠️ UN AJOUT QUI ÉCHOUE SE DIT (lot 2 achat, 28/09/2026). Au delà de 10 s ou sur un refus
     de Shopify, le message dit ce qui s'est passé et propose de recommencer avec le même
     formulaire. On resynchronise par `open()`, hors de la file : le tiroir montre le panier
     RÉEL, y compris quand un ajout trop lent a fini par passer. */
  function ajoutEchoue(form, texte) {
    var d = el(); if (!d) return;
    var body = $('.sgcart__body', d); if (!body) return;
    var box = $('[data-sgcart-erreur]', d);
    if (!box) {
      box = document.createElement('div');
      box.className = 'sgcart__erreur';
      box.setAttribute('data-sgcart-erreur', '');
      box.setAttribute('role', 'alert');
      body.insertBefore(box, body.firstChild);
    }
    box.innerHTML = '<p class="sgcart__erreur-txt">' + escapeHtml(texte) + '</p>' +
      '<button type="button" class="sgcart__erreur-btn">' + escapeHtml(T.reessayer || 'Réessayer') + '</button>';
    box.hidden = false;
    box.querySelector('button').addEventListener('click', function () {
      box.hidden = true;
      addFromForm(form);
    });
  }
  function effacerEchec() {
    var box = $('[data-sgcart-erreur]', el());
    if (box) box.hidden = true;
  }

  /* Add to cart straight from a product <form> — bypasses the theme's own handler. */
  function addFromForm(form) {
    openDrawer();
    effacerEchec();
    var d = el(); if (d) d.classList.add('is-busy');
    enqueue(function () {
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', '/cart');
      return api('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (x) { return { ok: r.ok, data: x }; }); })
        .then(function (res) {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
          if (!res.ok) {
            var raison = res.data && (res.data.description || res.data.message);
            ajoutEchoue(form, typeof raison === 'string' && raison ? raison : (T.ajout_echec || 'L’ajout au panier n’a pas abouti.'));
            open();
            return;
          }
          /* /cart/add.js rend l'article ajouté, pas le panier : l'état vient de la section. */
          var e = parseCart(sectionHTML(res.data));
          if (e) applyState(e); else open();
        }, function () {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
          ajoutEchoue(form, T.ajout_coupe || 'L’ajout au panier n’a pas pu être confirmé. Vérifiez la connexion, puis réessayez.');
          open();
        });
    });
  }

  /* ---------- delegated events ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-sgcart-close]')) { close(); return; }
    /* Pendant un calcul, le total affiché n'est pas encore le bon : on ne part pas en caisse. */
    if (t.closest('[data-sgcart-checkout]')) { if (inflight > 0 || sansPayant(etat)) e.preventDefault(); return; }

    var itemEl = t.closest('.sgcart-item');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      var item = etat && etat.items.filter(function (i) { return i.key === key; })[0];
      var q = item ? item.quantite : 1;
      if (t.closest('[data-sgcart-plus]'))   { if (item && !item.cadeau) changeQty(key, q + 1); return; }
      if (t.closest('[data-sgcart-minus]'))  { changeQty(key, Math.max(0, q - 1)); return; }
      if (t.closest('[data-sgcart-remove]')) { changeQty(key, 0); return; }
    }
  }
  function onDocClickCapture(e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var d = el();
    if (d && d.contains(t)) return;
    // Check specific selectors first (fast path)
    var a = t.closest([
      '.js-drawer-open-cart',
      '[data-sgcart-open]',
      '[data-sg-cart-open]',
      '.sg-header__cart',
      '[data-testid="cart-drawer-trigger"]',
      '.action__cart',               // Horizon 4 page-mode cart link class
      '.header-actions__cart-icon'   // inner cart-icon element
    ].join(','));
    if (!a) {
      // Fallback: any <a href="/cart"> (Horizon 4 page mode)
      var link = t.closest('a');
      if (link && /^\/cart(\/|\?|$)/.test(link.getAttribute('href') || '')) a = link;
    }
    if (!a) return;
    if (a.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }

  /* ---------- neutralise the theme's native cart drawer ---------- */
  function neutralizeNativeDrawer() {
    var de = document.documentElement;
    function strip() {
      if (de.classList.contains('js-drawer-open')) de.classList.remove('js-drawer-open');
      if (de.classList.contains('js-drawer-closing')) de.classList.remove('js-drawer-closing');
      if (document.body && document.body.classList.contains('js-drawer-open')) {
        document.body.classList.remove('js-drawer-open');
      }
    }
    strip();
    try {
      var obs = new MutationObserver(strip);
      obs.observe(de, { attributes: true, attributeFilter: ['class'] });
      if (document.body) obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  /* ---------- init ---------- */
  function init() {
    var d = el(); if (!d) return;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    neutralizeNativeDrawer();
    buildBar();
    var embarque = $('.sgcart__etat', d);
    applyState(parseCart(embarque ? embarque.innerHTML : ''));
    // Direct listeners on close triggers (bulletproof — bypass delegation issues)
    $$('[data-sgcart-close]', d).forEach(function (closeEl) {
      closeEl.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      closeEl.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
    });
    // Delegated capture — also handles dynamically added items
    d.addEventListener('click', onClick, true);
    document.addEventListener('click', onDocClickCapture, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });
    /* take over every product add-to-cart form (capture phase, before the theme) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(form);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.SGCart = { open: open, close: close, refresh: refresh, prix: formatMoney };
  window.HFCart = { open: open, close: close, refresh: refresh };
})();
